/* global window */
const viewportDimensions = () => {
  if (
    typeof window === "undefined" ||
    !window.innerWidth ||
    !window.innerHeight
  )
    return "";
  return `${window.innerWidth}:${window.innerHeight}`;
};

export default viewportDimensions;
